module.exports = __webpack_public_path__ + "static/media/ico-search.4187dfc0.svg";